import PropTypes from "prop-types";
import { parseCMSData } from "@/utils/cmsParser";
import ContactUs from "@/components/CustomComponents/ContactUs";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";

const ContactUsPage = ({ pageData = {}, description }) => {
  return (
    <ContactUs
      data={pageData?.pageSections?.[0] || {}}
      descriptionRow={description}
    />
  );
};

export async function getStaticProps({ preview, locale }) {
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
  } = await getPageShellDataSafely({
    slug: `/contact-us`,
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
    locale,
  });

  const pageDataRaw = items?.[0];
  const description =
    pageDataRaw?.fields?.pageSections?.[0].fields?.description;
  if (!pageDataRaw) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  const pageData = parseCMSData(pageDataRaw);
  // Body components use parsed fields; CustomHead consumes the Contentful SEO Entry.
  if (pageDataRaw.fields?.seoMetadata) {
    pageData.seoMetadata = pageDataRaw.fields.seoMetadata;
  }
  return {
    props: {
      pageData,
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      description: description,
    },
    revalidate: 60,
  };
}

ContactUsPage.propTypes = {
  pageData: PropTypes.object,
  description: PropTypes.string,
};

export default ContactUsPage;
